var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrosoftExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "microsoft-excel",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.78,
    height: 18,
    viewBox: "0 0 18.78 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_983",
    "data-name": "Group 983"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1263",
    "data-name": "Path 1263",
    d: "M10.807,10.713a.391.391,0,0,0-.332-.078L.3,12.983a.391.391,0,0,0-.3.385v13.3a.391.391,0,0,0,.332.387L10.5,28.621a.391.391,0,0,0,.451-.387V11.02A.391.391,0,0,0,10.807,10.713Z",
    transform: "translate(0 -10.626)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1264",
    "data-name": "Path 1264",
    d: "M285.549,68.244h-7.825a.391.391,0,0,1,0-.783h7.434v-13.3h-7.434a.391.391,0,0,1,0-.782h7.825a.391.391,0,0,1,.391.391V67.853A.391.391,0,0,1,285.549,68.244Z",
    transform: "translate(-267.161 -51.809)",
    fill: "currentColor"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_984",
    "data-name": "Group 984",
    transform: "translate(3.123 5.469)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1265",
    className: "ms-excel-x",
    "data-name": "Path 1265",
    d: "M89.459,166.812a.391.391,0,0,1-.332-.184l-3.912-6.26a.391.391,0,0,1,.65-.436l.013.022,3.912,6.26a.391.391,0,0,1-.332.6Z",
    transform: "translate(-85.149 -159.758)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1266",
    className: "ms-excel-x",
    "data-name": "Path 1266",
    d: "M85.745,166.791a.391.391,0,0,1-.331-.6l3.912-6.26a.391.391,0,0,1,.677.392l-.013.022-3.912,6.26A.391.391,0,0,1,85.745,166.791Z",
    transform: "translate(-85.347 -159.737)",
    fill: "#FFFFFF"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_985",
    "data-name": "Group 985",
    transform: "translate(10.172 1.568)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1267",
    "data-name": "Path 1267",
    d: "M363.058,68.243a.391.391,0,0,1-.391-.391V53.767a.391.391,0,1,1,.783,0V67.852A.391.391,0,0,1,363.058,68.243Z",
    transform: "translate(-359.537 -53.376)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1268",
    "data-name": "Path 1268",
    d: "M285.549,374.158h-7.825a.391.391,0,0,1,0-.782h7.825a.391.391,0,1,1,0,.782Z",
    transform: "translate(-277.333 -361.639)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1269",
    "data-name": "Path 1269",
    d: "M285.549,310.158h-7.825a.391.391,0,0,1,0-.782h7.825a.391.391,0,1,1,0,.782Z",
    transform: "translate(-277.333 -299.986)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1270",
    "data-name": "Path 1270",
    d: "M285.549,246.158h-7.825a.391.391,0,0,1,0-.782h7.825a.391.391,0,1,1,0,.782Z",
    transform: "translate(-277.333 -238.334)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1271",
    "data-name": "Path 1271",
    d: "M285.549,182.159h-7.825a.391.391,0,0,1,0-.783h7.825a.391.391,0,0,1,0,.783Z",
    transform: "translate(-277.333 -176.681)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1272",
    "data-name": "Path 1272",
    d: "M285.549,118.159h-7.825a.391.391,0,0,1,0-.783h7.825a.391.391,0,0,1,0,.783Z",
    transform: "translate(-277.333 -115.029)",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftExcel);
export default __webpack_public_path__ + "static/media/microsoft-excel.669b684d61d50a990534c22b354e65cd.svg";
export { ForwardRef as ReactComponent };